import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { PasswordRecoveryService } from '../password-recovery/services/password-recovery.service';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetGuard {
  constructor(
    private passRecoveryService: PasswordRecoveryService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const token = route.paramMap?.get('passwordResetToken');
    const username = route.paramMap?.get('username');
    return this.passRecoveryService.checkResetTokenValid(username, token).pipe(
      map((res: Response) => {
        if (res.status === 200) {
          return true;
        }
        this.router.navigate(['/login']);
        return false;
      }),
      catchError((error) => {
        setTimeout(() => {
          // Map error enum to static English messages (translations removed)
          let messageText = 'Token is invalid';
          if (error.status === HttpStatusCode.NotFound) {
            messageText = 'User or token could not be found. Please request a new link';
          } else if (error.status === HttpStatusCode.BadRequest) {
            messageText = 'The token has expired because it is older than 48h. Please request a new link';
          }

          this.snackBar.open(messageText, 'Close', {
            duration: 5000,
            panelClass: ['snackbar-error'],
          });
        }, 800);

        this.router.navigate(['/login']);

        return of(false);
      }),
    );
  }
}
